import { makeStyles } from '@rbx/ui';

const useMobileMilestoneNavigationStyles = makeStyles()((theme) => ({
  container: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    borderRadius: '16px 16px 0 0',
    backgroundColor: theme.palette.background.paper,
    maxHeight: '85vh',
    overflow: 'hidden',
    boxShadow: theme.shadows[8],
    [theme.breakpoints.up('Large')]: {
      display: 'none',
    },
  },

  dragHandle: {
    display: 'flex',
    justifyContent: 'center',
    padding: '12px 0 8px 0',
    cursor: 'pointer',
  },

  dragIndicator: {
    width: '40px',
    height: '4px',
    backgroundColor: theme.palette.secondary.main,
    borderRadius: '2px',
  },

  clickableHeader: {
    padding: '10px 20px 16px 20px',
    cursor: 'pointer',
    userSelect: 'none',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:active': {
      backgroundColor: theme.palette.action.selected,
    },
  },

  expandedContent: {
    maxHeight: 'calc(65vh - 200px)',
    overflowY: 'auto',
    padding: '0 20px 0 20px',

    '& .MuiGrid-container': {
      minWidth: 'auto',
      maxWidth: 'none',
    },
  },

  continueSection: {
    padding: '10px 20px 0 20px',
    backgroundColor: theme.palette.background.paper,
  },
}));

export default useMobileMilestoneNavigationStyles;
